import { AuthLogicActions } from './actions';

const updateUserData = AuthLogicActions.updateUser;

export default updateUserData;
